module.exports = __webpack_public_path__ + "img/20191112152848360截图20191112151656662.b7c4eaf9.jpg";